import axios from 'axios';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import { API_BASE_URL as BASE_URL, WS_BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/chat`;

// 채팅방 리스트 조회
export const getChatroomList = async () => {
  try {
    const response = await axios.get(API_BASE_URL);
    return response.data;
  } catch (error) {
    console.error('채팅방 리스트 조회 실패:', error);
    throw error;
  }
};

// 채팅방 정보 조회 (ChatroomResponse)
export const getChatroomInfo = async (meetingId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${meetingId}/chatroom-info`);
    return response.data;
  } catch (error) {
    console.error('채팅방 정보 조회 실패:', error);
    throw error;
  }
};

// 채팅 메시지 리스트 조회 (페이지네이션) - List<Chat> 반환
export const getChatListPaginated = async (meetingId, page = 0) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${meetingId}/chats`, {
      params: { page }
    });
    return response.data; // List<Chat> 직접 반환
  } catch (error) {
    console.error('채팅 리스트 조회 실패:', error);
    throw error;
  }
};

// 웹소켓 클라이언트 관리
let stompClient = null;

// 웹소켓 연결
export const connectWebSocket = (meetingId, onMessageReceived) => {
  return new Promise((resolve, reject) => {
    try {
      const token = localStorage.getItem('token');
      
      // SockJS 소켓 생성
      const socket = new SockJS(WS_BASE_URL);
      
      // STOMP 클라이언트 생성
      stompClient = new Client({
        webSocketFactory: () => socket,
        connectHeaders: {
          Authorization: `Bearer ${token}`
        },
        debug: (str) => {
          // console.log('STOMP Debug:', str);
        },
        onConnect: (frame) => {
          // console.log('웹소켓 연결 성공:', frame);
          
          // 채팅방 구독
          stompClient.subscribe(`/topic/chat/${meetingId}`, (message) => {
            const chatMessage = JSON.parse(message.body);
            onMessageReceived(chatMessage);
          }, {
            Authorization: `Bearer ${token}`
          });
          
          resolve(stompClient);
        },
        onStompError: (frame) => {
          console.error('STOMP 오류:', frame);
          reject(new Error('웹소켓 연결 실패'));
        },
        onWebSocketError: (error) => {
          console.error('웹소켓 오류:', error);
          reject(error);
        }
      });
      
      // 연결 활성화
      stompClient.activate();
      
    } catch (error) {
      console.error('웹소켓 연결 중 오류:', error);
      reject(error);
    }
  });
};

// 메시지 전송
export const sendChatMessage = (meetingId, message) => {
  if (stompClient && stompClient.connected) {
    const token = localStorage.getItem('token');
    
    stompClient.publish({
      destination: `/app/chat/${meetingId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        type: 'TEXT',
        content: message
      })
    });
  } else {
    console.error('웹소켓이 연결되지 않았습니다.');
    throw new Error('웹소켓이 연결되지 않았습니다.');
  }
};

// 웹소켓 연결 해제
export const disconnectWebSocket = () => {
  if (stompClient) {
    stompClient.deactivate();
    stompClient = null;
    // console.log('웹소켓 연결 해제됨');
  }
};
